module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions-container"
  }, [_c('div', {
    staticClass: "actions__header"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.eventDate))]), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions__content"
  }, [_c('div', {
    staticClass: "div container"
  }, [_c('div', {
    staticClass: "actions-icon"
  }, _vm._l((_vm.eventActions), function(eventAction) {
    return _c('div', {
      staticClass: "action-icon"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": eventAction.imgSrc,
        "alt": ""
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, _vm._l((_vm.eventActions), function(eventAction) {
    return _c('div', {
      staticClass: "action"
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(eventAction.title)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "textContent": _vm._s(eventAction.text)
      }
    })])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4ec169a4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Actions.vue
// module id = 38
// module chunks = 0